import { Component, OnInit } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { EPrijemnicaStavka } from './eprijemnica-stavka';
import { EPrijemnicaStavkaDodatniAtribut } from './eprijemnica-stavka-dodatni-atribut';

@Component({
  selector: 'yt-eprijemnica-stavka-dodatni-atribut-inline-update',
  templateUrl: './eprijemnica-stavka-dodatni-atribut-inline-update.component.html'
})
export class EPrijemnicaStavkaDodatniAtributInlineUpdateComponent
 extends BaseInlineUpdateComponent<EPrijemnicaStavkaDodatniAtribut> {
  constructor(protected inlineContainerService: InlineContainerService<EPrijemnicaStavkaDodatniAtribut>){
    super(inlineContainerService);
  }
}
